import { useIntl } from '@grandvisionhq/state';
import { useSunglassesEcommContext } from '../context/SunglassesEcommContext.js';

const useSunglassesPriceFrom = ()=>{
    const { getLabel  } = useIntl();
    const { shouldDisplayFromPrice  } = useSunglassesEcommContext();
    const fromPricePrefix = shouldDisplayFromPrice ? getLabel('products.price.sunglasses.from', {
        hideLabelKey: true
    }) : undefined;
    return {
        shouldDisplayFromPrice,
        fromPricePrefix
    };
};

export { useSunglassesPriceFrom };
//# sourceMappingURL=use-sunglasses-price-from.js.map
